const LEFT_BRACKET = 'LEFT_BRACKET';
const CLOSING_TAG = 'CLOSING_TAG';
const TAG_TEXT = 'TAG_TEXT';
const TAG_NAME = 'TAG_NAME';
const TAG_CLOSED = 'TAG_CLOSED';
const TAG_VALUE = 'TAG_VALUE';

const parse = (input = '') => {
  const nodes = [];

  let state = TAG_CLOSED;

  for (let i = 0; i < input.length; i += 1) {
    const char = input[i];
    const isWhitespace = char.match(/\s/);

    if (char === '[') {
      state = LEFT_BRACKET;
    } else if (state === LEFT_BRACKET && char === '/') {
      state = CLOSING_TAG;
    } else if (!isWhitespace && state === LEFT_BRACKET) {
      state = TAG_NAME;
      nodes.push({ tagName: char, text: '', value: '' });
    } else if (state === TAG_NAME && char === '=') {
      state = TAG_VALUE;
    } else if (state === CLOSING_TAG && char === ']') {
      state = TAG_CLOSED;
    } else if (char === ']') {
      state = TAG_TEXT;
    } else if (state === TAG_CLOSED) {
      state = TAG_TEXT;
      nodes.push({ tagName: 'text', text: char, value: '' });
    } else if (!isWhitespace && state === TAG_NAME) {
      nodes[nodes.length - 1].tagName += char;
    } else if (state === TAG_TEXT) {
      nodes[nodes.length - 1].text += char;
    } else if (!isWhitespace && state === TAG_VALUE) {
      nodes[nodes.length - 1].value += char;
    }
  }

  return nodes;
};

export default parse;
